import Reveal from "@/components/site/Reveal";
import { Check } from "lucide-react";

/* Regiones de Chile, norte → sur. Cobertura nacional completa. */
const REGIONS = [
  "Arica y Parinacota", "Tarapacá", "Antofagasta", "Atacama",
  "Coquimbo", "Valparaíso", "Metropolitana", "O'Higgins",
  "Maule", "Ñuble", "Biobío", "La Araucanía",
  "Los Ríos", "Los Lagos", "Aysén", "Magallanes",
];

export default function ChileCoverage() {
  return (
    <section className="py-20 md:py-28 bg-[#0B1020] relative overflow-hidden" data-testid="coverage-section">
      <div
        className="pointer-events-none absolute inset-0"
        style={{ background: "radial-gradient(50% 40% at 80% 20%, rgba(56,64,145,0.35), rgba(11,16,32,0) 70%)" }}
      />
      <div className="container mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <p className="text-xs tracking-[0.3em] font-semibold text-[#0FB4B7] uppercase mb-4">
              Cobertura nacional total
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
              Las 16 regiones de Chile.<br />
              <span className="text-[#0FB4B7]">Todas.</span>
            </h2>
            <p className="text-white/60 text-lg leading-relaxed mb-8 max-w-lg">
              Somos la única red técnica independiente con cobertura en el
              <span className="text-white font-semibold"> 100% del territorio nacional</span>:
              de Arica a Magallanes. Hospitales, universidades, redes de clínicas y faenas
              mineras confían en el mismo estándar, esté donde esté tu equipo. Si tienes
              sucursales en distintas ciudades, las atendemos todas.
            </p>
            <div className="grid grid-cols-3 gap-4 max-w-md">
              {[
                { k: "16/16", l: "regiones cubiertas" },
                { k: "1", l: "estándar único" },
                { k: "100%", l: "documentado" },
              ].map((s) => (
                <div key={s.l} className="rounded-2xl border border-white/10 bg-white/[0.04] p-4">
                  <p className="font-heading text-2xl md:text-3xl font-bold text-[#0FB4B7]">{s.k}</p>
                  <p className="text-[11px] text-white/50 mt-1 leading-tight">{s.l}</p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="relative pl-6">
              {/* eje norte–sur (la geografía larga de Chile) */}
              <div className="absolute left-[10px] top-2 bottom-2 w-px bg-gradient-to-b from-[#0FB4B7]/20 via-[#0FB4B7]/70 to-[#0FB4B7]/20" />
              <ul className="space-y-1.5">
                {REGIONS.map((r) => (
                  <li key={r} className="relative flex items-center gap-3">
                    <span className="relative z-10 flex h-5 w-5 -ml-[9px] items-center justify-center rounded-full bg-[#0FB4B7] text-[#0B1020]">
                      <Check className="h-3 w-3" strokeWidth={3} />
                    </span>
                    <span className="text-sm md:text-[15px] text-white font-medium">{r}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-5 ml-3 inline-flex items-center gap-2 rounded-full border border-[#0FB4B7]/30 bg-[#0FB4B7]/10 px-4 py-1.5">
                <Check className="h-3.5 w-3.5 text-[#0FB4B7]" strokeWidth={3} />
                <span className="text-xs font-semibold text-[#0FB4B7] uppercase tracking-wider">
                  Cobertura de Arica a Magallanes
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
